module.exports = __webpack_public_path__ + "img/apple-touch-icon.9ef99633.png";